import React from 'react';
import PropTypes from 'prop-types';

const EtchMyStore = (props) => {

  const { opts = {} } = props;
  const { id } = opts;

  return (
    <div id="myStoreModule" className="etch-analytics" />
  );
};

EtchMyStore.propTypes = {
  opts: PropTypes.shape({
    id: PropTypes.string
  })
};

EtchMyStore.defaultProps = {
  opts: null
};

export default EtchMyStore;
